import React from 'react';
import { useLocation } from 'react-router-dom';
import '../../styles/admin-layout.css';

export default function AdminRouteLayout({ children }) {
  const { pathname } = useLocation();
  return /^\/admin(?:\/|$)/.test(pathname) ? (
    <div className='admin-layout'>{children}</div>
  ) : (
    children
  );
}
